// extracted by mini-css-extract-plugin
export var box = "index-module--box--+gj9M";
export var clearfix = "index-module--clearfix--DLASI";
export var groupContainer = "index-module--groupContainer--Lvxr4";
export var iconGroup = "index-module--iconGroup--zQIMO";
export var iconIntro = "index-module--iconIntro--yyCFg";
export var iconItem = "index-module--iconItem--CX-S1";
export var img = "index-module--img--UjY5O";
export var title = "index-module--title--rcYYJ";